import script from "./RentersTenants.vue?vue&type=script&setup=true&lang=js"
export * from "./RentersTenants.vue?vue&type=script&setup=true&lang=js"

import "./RentersTenants.vue?vue&type=style&index=0&id=3a4f8df5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4f8df5"]])

export default __exports__